import "./relatorioUnidade.css";

// relatorioUnidade.css keys on these Modal parts to print only the report, flowing across pages.
export const relatorioModalClassNames = {
  root: "relatorio-unidade",
  overlay: "relatorio-unidade__overlay",
  inner: "relatorio-unidade__inner",
  content: "relatorio-unidade__content",
  header: "relatorio-unidade__header",
  body: "relatorio-unidade__body",
};

// The body is as wide as the printable A4 area (718px, see .relatorio-unidade__mapa), so the
// report looks on screen the way it prints.
export const RELATORIO_MODAL_PADDING = 16;
export const RELATORIO_MODAL_SIZE = 718 + 2 * RELATORIO_MODAL_PADDING;

// Columns follow the report width, not the viewport: the viewport is the screen on screen and the
// page in print, which would stack the columns only on paper.
export const RELATORIO_GRID_BREAKPOINTS = { xs: "300px", sm: "600px", md: "700px", lg: "900px", xl: "1100px" };

// Photos come oldest first, dated dd/MM/yyyy, and some carry no date. The report opens on the most
// recent dated one; with no dates at all, on the last of the list.
export function indiceFotoMaisRecente(datas: (string | null | undefined)[] | undefined, total: number): number {
  let melhor = -1;
  let melhorChave = "";
  (datas ?? []).forEach((data, i) => {
    const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((data ?? "").trim());
    if (!m) return;
    const chave = `${m[3]}${m[2]}${m[1]}`;
    if (chave >= melhorChave) {
      melhorChave = chave;
      melhor = i;
    }
  });
  return melhor >= 0 ? melhor : Math.max(total - 1, 0);
}
